import { call, takeLatest } from 'redux-saga/effects';
import { captureException } from '../../../client/sentry';
import { graphql } from '../../../globals/api/requests';
import {
  ORDER_LISTS_REQUEST,
  ORDER_LIST_ITEMS_REQUEST,
} from '../actions/lists';

export function* orderLists({ listIds }) {
  try {
    const response = yield call(
      graphql,
      `mutation listsOrder($listIds: [Int!]!) {
        listsOrder(listIds: $listIds) {
          success
        }
      }`,
      {
        listIds,
      }
    );

    if (response.errors) {
      return;
    }
  } catch (err) {
    yield call(captureException, err);
  }
}

export function* orderListItems({ listItemIds, listId }) {
  try {
    const response = yield call(
      graphql,
      `mutation listItemsOrder($listId: Int!, $listItemIds: [Int!]!) {
        listItemsOrder(listId: $listId, listItemIds: $listItemIds) {
          success
        }
      }`,
      {
        listItemIds,
        listId,
      }
    );

    if (response.errors) {
      return;
    }
  } catch (err) {
    yield call(captureException, err);
  }
}

function* mySaga() {
  yield takeLatest(ORDER_LISTS_REQUEST, orderLists);
  yield takeLatest(ORDER_LIST_ITEMS_REQUEST, orderListItems);
}

export default mySaga;
